import React from 'react';
import Hero from './Hero';
import PackageCard from './PackageCard';
import DestinationCard from './DestinationCard';
import BlogCard from './BlogCard';
import Carousel from './Carousel';
import { rajasthanPackages, destinations, experienceCategories, blogs } from '../data/toursData';

const HomePage = ({ 
  setSelectedPackage, 
  setIsPackageDetailsOpen, 
  setEnquiryPackageData, 
  setIsEnquiryOpen 
}) => {
  const handlePackageEnquiry = (packageData) => {
    setEnquiryPackageData(packageData);
    setIsEnquiryOpen(true);
  };

  return (
    <>
      <Hero />

      {/* Rajasthan Destinations Carousel */}
      <section className="incredible-india" id="destinations">
        <div className="container">
          <div className="section-header">
            <h2>Rangeelo Rajasthan Destinations</h2>
            <p>Discover amazing tours across the length and breadth of incredible India</p>
          </div>
          <Carousel 
            items={destinations} 
            renderItem={(destination) => (
              <DestinationCard
                key={destination.id}
                image={destination.image}
                title={destination.title}
                description={destination.description}
                price={destination.price}
                onEnquiryClick={() => handlePackageEnquiry(destination)}
              />
            )}
          />
          <div className="text-center">
            <button 
              className="btn-primary personalized-packages-btn"
              onClick={() => {
                setEnquiryPackageData(null);
                setIsEnquiryOpen(true);
              }}
            >
              <span>Visit your favourite destinations</span>
            </button>
          </div>
        </div>
      </section>

      {/* Popular Rajasthan Tour Packages */}
      <section className="india-packages" id="rajasthan-tours">
        <div className="container">
          <div className="section-header">
            <h2>Popular Rajasthan Tour Packages</h2>
            <p>Forget your budget hassle and discover the magic of Rajasthan with our top-rated tour packages with personal customizations! From royal palaces to desert adventures, we offer unforgettable experiences for every traveler and budget. Don't miss your chance to explore Rajasthan's wonders - start planning the vacation of a lifetime!</p>
          </div>
          <div className="packages-grid">
            {rajasthanPackages.map((pkg) => (
              <PackageCard
                key={pkg.id}
                image={pkg.image}
                title={pkg.title}
                duration={pkg.duration}
                link={pkg.link}
                onPackageClick={() => {
                  if (pkg.detailedPackage) {
                    setSelectedPackage(pkg);
                    setIsPackageDetailsOpen(true);
                  }
                }}
              />
            ))}
          </div>
          <div className="text-center">
            <button 
              className="btn-primary personalized-packages-btn"
              onClick={() => {
                setEnquiryPackageData(null);
                setIsEnquiryOpen(true);
              }}
            >
              <span>Get your personalized package</span>
            </button>
          </div>
        </div>
      </section>

      {/* Rajasthan Experiences */}
      <section className="experience-categories" id="experiences">
        <div className="container">
          <div className="section-header">
            <h2>Experiences in Rajasthan</h2>
            <p>We don't just create packages, we offer immersive experiences - from forts to festivals, culture to cuisine!</p>
          </div>
          <div className="experience-grid">
            {experienceCategories.map((experience) => (
              <div key={experience.id} className="experience-card">
                <div className="experience-icon">{experience.icon}</div>
                <h3>{experience.title}</h3>
                <p>{experience.description}</p>
                <div className="experience-destinations">
                  {experience.destinations.slice(0, 3).map((dest, index) => (
                    <span key={index} className="destination-tag">{dest}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="text-center">
            <button 
              className="btn-primary personalized-packages-btn"
              onClick={() => {
                setEnquiryPackageData(null);
                setIsEnquiryOpen(true);
              }}
            >
              <span>Choose your experience</span>
            </button>
          </div>
        </div>
      </section>

      {/* Travel Guide & Blog */}
      <section className="blog-section" id="blog-section">
        <div className="container">
          <div className="section-header">
            <h2>Unravel the Mysteries of Rajasthan</h2>
            <p>Haunted and Enigmatic Tales Await - Discover the Supernatural Side of Rajasthan</p>
          </div>
          <div className="blog-grid">
            {blogs.map((blog) => (
              <BlogCard
                key={blog.id}
                image={blog.image}
                category={blog.category}
                title={blog.title}
                excerpt={blog.excerpt}
                date={blog.date}
                link={blog.link}
              />
            ))}
          </div>
          <div className="text-center">
            <button 
              className="btn-primary personalized-packages-btn"
              onClick={() => {
                setEnquiryPackageData(null);
                setIsEnquiryOpen(true);
              }}
            >
              <span>Let's Unravel a Mystery</span>
            </button>
          </div>
        </div>
      </section>

      {/* Cab Rental Section */}
      <section className="cab-rental" id="cab-rental">
        <div className="container">
          <div className="section-header">
            <h2>Cab Rental Services</h2>
            <p>Comfortable and reliable transportation for your Rajasthan journey</p>
          </div>
          <div className="cab-rental-content">
            <div className="cab-services-grid">
              <div className="cab-service-card">
                <div className="cab-icon">🚗</div>
                <h3>City Tours</h3>
                <p>Explore Rajasthan cities with our experienced drivers</p>
              </div>
              <div className="cab-service-card">
                <div className="cab-icon">🚙</div>
                <h3>Airport Transfers</h3>
                <p>Hassle-free pickup and drop services</p>
              </div>
              <div className="cab-service-card">
                <div className="cab-icon">🚐</div>
                <h3>Group Travel</h3>
                <p>Spacious vehicles for family and group tours</p>
              </div>
              <div className="cab-service-card">
                <div className="cab-icon">🚕</div>
                <h3>One Way Taxi</h3>
                <p>Comfortable one-way rides to your destination</p>
              </div>
            </div>
            <div className="text-center">
              <button 
                className="btn-primary cab-enquiry-btn"
                onClick={() => {
                  // Find and trigger the floating enquiry
                  const enquiryBtn = document.querySelector('.floating-btn');
                  if (enquiryBtn) enquiryBtn.click();
                }}
              >
                Book Your Cab Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Customer Logos Section */}
      <section className="customer-logos" id="corporate-travel">
        <div className="container">
          <div className="section-header">
            <h2>Trusted by Leading Organizations</h2>
            <p>We are grateful to have served the following prestigious organizations and countless other customers over the years.</p>
          </div>
          <div className="logos-container">
            <div className="logos-scroll">
              <div className="logo-item">
                <img src="/images/customer/customer_logo_1.png" alt="Customer Logo 1" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_2.png" alt="Customer Logo 2" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_3.png" alt="Customer Logo 3" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_4.png" alt="Customer Logo 4" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_5.png" alt="Customer Logo 5" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_6.png" alt="Customer Logo 6" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_7.png" alt="Customer Logo 7" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_8.png" alt="Customer Logo 8" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_9.png" alt="Customer Logo 9" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_10.png" alt="Customer Logo 10" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_11.png" alt="Customer Logo 11" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_12.png" alt="Customer Logo 12" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_13.png" alt="Customer Logo 13" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_14.png" alt="Customer Logo 14" />
              </div>
              {/* Duplicate logos for seamless loop */}
              <div className="logo-item">
                <img src="/images/customer/customer_logo_1.png" alt="Customer Logo 1" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_2.png" alt="Customer Logo 2" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_3.png" alt="Customer Logo 3" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_4.png" alt="Customer Logo 4" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_5.png" alt="Customer Logo 5" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_6.png" alt="Customer Logo 6" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_7.png" alt="Customer Logo 7" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_8.png" alt="Customer Logo 8" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_9.png" alt="Customer Logo 9" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_10.png" alt="Customer Logo 10" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_11.png" alt="Customer Logo 11" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_12.png" alt="Customer Logo 12" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_13.png" alt="Customer Logo 13" />
              </div>
              <div className="logo-item">
                <img src="/images/customer/customer_logo_14.png" alt="Customer Logo 14" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Corporate Travel Section */}
      <section className="corporate-travel" id="corporate-services">
        <div className="container">
          <div className="section-header">
            <h2>Corporate Travel Solutions</h2>
            <p>Professional travel management services for your business needs</p>
          </div>
          <div className="corporate-content">
            <p>We provide customized corporate travel solutions including employee travel, business meetings, conferences, and incentive tours. Our dedicated team ensures seamless travel experiences for your organization.</p>
            <a href="/corporate-travel" className="btn-primary">Explore Corporate Solutions</a>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;